/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dusty_Scarlet_Falcon_GrowInputs */

const en_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No additional activations necessary at this time.`)
};

const id_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak diperlukan aktivasi tambahan saat ini.`)
};

const ms_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada pengaktifan tambahan diperlukan pada masa ini.`)
};

const ca_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No calen activacions addicionals en aquest moment.`)
};

const cs_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V tuto chvíli nejsou nutné žádné další aktivace.`)
};

const da_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen yderligere aktiveringer nødvendige på nuværende tidspunkt.`)
};

const de_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derzeit sind keine weiteren Aktivierungen erforderlich.`)
};

const et_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hetkel pole täiendavad aktiveerimised vajalikud.`)
};

const es_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se requieren activaciones adicionales en este momento.`)
};

const fr_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune activation supplémentaire n’est nécessaire pour le moment.`)
};

const hr_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenutno nisu potrebne dodatne aktivacije.`)
};

const it_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna attivazione aggiuntiva necessaria al momento.`)
};

const lv_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šobrīd papildu aktivizācijas nav nepieciešamas.`)
};

const lt_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šiuo metu papildomi aktyvavimai nereikalingi.`)
};

const hu_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelenleg nincs szükség további aktiválásokra.`)
};

const nl_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op dit moment zijn er geen extra activeringen nodig.`)
};

const nb_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ytterligere aktiveringer nødvendig på dette tidspunktet.`)
};

const pl_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecnie nie są wymagane dodatkowe aktywacje.`)
};

const pt_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma ativação adicional é necessária no momento.`)
};

const ro_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu sunt necesare activări suplimentare în acest moment.`)
};

const sk_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V tejto chvíli nie sú potrebné žiadne ďalšie aktivácie.`)
};

const sl_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenutno dodatne aktivacije niso potrebne.`)
};

const fi_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisäaktivointeja ei tarvita tällä hetkellä.`)
};

const sv_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga ytterligare aktiveringar behövs för tillfället.`)
};

const vi_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không cần thêm lượt kích hoạt nào vào lúc này.`)
};

const tr_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu anda ek etkinleştirmeye gerek yok.`)
};

const el_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν χρειάζονται επιπλέον ενεργοποιήσεις αυτή τη στιγμή.`)
};

const bg_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В момента не са необходими допълнителни активирания.`)
};

const ru_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные активации в данный момент не требуются.`)
};

const sr_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У овом тренутку нису потребне додатне активације.`)
};

const uk_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зараз додаткові активації не потрібні.`)
};

const ka_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ამჟამად დამატებითი გააქტიურებები არ არის საჭირო.`)
};

const hi_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस समय कोई अतिरिक्त सक्रियण आवश्यक नहीं है।`)
};

const th_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่จำเป็นต้องเปิดใช้งานเพิ่มเติมในขณะนี้`)
};

const ko_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 추가 활성화가 필요하지 않습니다.`)
};

const zh_tw_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前無需額外的啟用次數。`)
};

const ja_dusty_scarlet_falcon_grow = /** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現時点で追加のアクティベーションは必要ありません。`)
};

/** @type {(inputs: Dusty_Scarlet_Falcon_GrowInputs) => LocalizedString} */
const zh_dusty_scarlet_falcon_grow = en_dusty_scarlet_falcon_grow;

/**
* | output |
* | --- |
* | "No additional activations necessary at this time." |
*
* @param {Dusty_Scarlet_Falcon_GrowInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const dusty_scarlet_falcon_grow = /** @type {((inputs?: Dusty_Scarlet_Falcon_GrowInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dusty_Scarlet_Falcon_GrowInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dusty_scarlet_falcon_grow(inputs)
	if (locale === "ms") return ms_dusty_scarlet_falcon_grow(inputs)
	if (locale === "ca") return ca_dusty_scarlet_falcon_grow(inputs)
	if (locale === "cs") return cs_dusty_scarlet_falcon_grow(inputs)
	if (locale === "da") return da_dusty_scarlet_falcon_grow(inputs)
	if (locale === "de") return de_dusty_scarlet_falcon_grow(inputs)
	if (locale === "et") return et_dusty_scarlet_falcon_grow(inputs)
	if (locale === "es") return es_dusty_scarlet_falcon_grow(inputs)
	if (locale === "fr") return fr_dusty_scarlet_falcon_grow(inputs)
	if (locale === "hr") return hr_dusty_scarlet_falcon_grow(inputs)
	if (locale === "it") return it_dusty_scarlet_falcon_grow(inputs)
	if (locale === "lv") return lv_dusty_scarlet_falcon_grow(inputs)
	if (locale === "lt") return lt_dusty_scarlet_falcon_grow(inputs)
	if (locale === "hu") return hu_dusty_scarlet_falcon_grow(inputs)
	if (locale === "nl") return nl_dusty_scarlet_falcon_grow(inputs)
	if (locale === "nb") return nb_dusty_scarlet_falcon_grow(inputs)
	if (locale === "pl") return pl_dusty_scarlet_falcon_grow(inputs)
	if (locale === "pt") return pt_dusty_scarlet_falcon_grow(inputs)
	if (locale === "ro") return ro_dusty_scarlet_falcon_grow(inputs)
	if (locale === "sk") return sk_dusty_scarlet_falcon_grow(inputs)
	if (locale === "sl") return sl_dusty_scarlet_falcon_grow(inputs)
	if (locale === "fi") return fi_dusty_scarlet_falcon_grow(inputs)
	if (locale === "sv") return sv_dusty_scarlet_falcon_grow(inputs)
	if (locale === "vi") return vi_dusty_scarlet_falcon_grow(inputs)
	if (locale === "tr") return tr_dusty_scarlet_falcon_grow(inputs)
	if (locale === "el") return el_dusty_scarlet_falcon_grow(inputs)
	if (locale === "bg") return bg_dusty_scarlet_falcon_grow(inputs)
	if (locale === "ru") return ru_dusty_scarlet_falcon_grow(inputs)
	if (locale === "sr") return sr_dusty_scarlet_falcon_grow(inputs)
	if (locale === "uk") return uk_dusty_scarlet_falcon_grow(inputs)
	if (locale === "ka") return ka_dusty_scarlet_falcon_grow(inputs)
	if (locale === "hi") return hi_dusty_scarlet_falcon_grow(inputs)
	if (locale === "th") return th_dusty_scarlet_falcon_grow(inputs)
	if (locale === "ko") return ko_dusty_scarlet_falcon_grow(inputs)
	if (locale === "zh") return zh_dusty_scarlet_falcon_grow(inputs)
	if (locale === "zh-tw") return zh_tw_dusty_scarlet_falcon_grow(inputs)
	if (locale === "ja") return ja_dusty_scarlet_falcon_grow(inputs)
	return en_dusty_scarlet_falcon_grow(inputs)
});